module.exports = __webpack_public_path__ + "ac.no1.d3745100.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ac.no1.jpg
// module id = lv3g
// module chunks = 0